import { useEffect, useRef } from 'react'
import { registerDeckCard } from '@/lib/deck'
import { usePrefersReducedMotion } from './useInView'

/**
 * Enrols an element in the 3D scroll deck.
 *
 * Under `prefers-reduced-motion` the element is never registered, so it simply
 * renders flat — the effect is decorative and nothing depends on it.
 */
export function useDeckCard<T extends HTMLElement>(strength = 1) {
  const ref = useRef<T>(null)
  const reduced = usePrefersReducedMotion()

  useEffect(() => {
    const node = ref.current
    if (!node || reduced) return
    return registerDeckCard(node, strength)
  }, [reduced, strength])

  return ref
}
